import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchResourceDelete,
  fetchResourceUpdate,
  fetchResourcesGet
} from "./fetching";
import type { fetchMutationKey } from "@dealer-center/ddc-pages-resources-interface";
import type { compareItem } from "@dealer-center/core-custom-components";
import type { resources } from "@dealer-center/ddc-pages-resources-interface";

const queryKeyBase = "ddc-pages-resources";

export function useDealerCodesGetTypesForCompare(account?: string) {
  return useQuery({
    queryKey: [queryKeyBase, account],
    queryFn: () => fetchResourcesGet(account),
    enabled: !!account,
    select: data => resourcesToCompare(data || []),
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}

const resourcesToCompare = (resources: resources[]): compareItem[] => {
  return resources.map(resource => {
    return {
      label: resource.name,
      value: resource.granted
    };
  });
};

export function useDealerCodesGetTypes(account?: string) {
  return useQuery({
    queryKey: [queryKeyBase, account],
    queryFn: () => fetchResourcesGet(account),
    enabled: !!account
  });
}

export function useDealerCodesGetTypesForImport(account?: string) {
  return useQuery({
    queryKey: [queryKeyBase, account],
    queryFn: () => fetchResourcesGet(account),
    enabled: !!account,
    select: data =>
      data?.filter(resource => resource.granted).map(resource => resource.name)
  });
}

export function useResourceUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    mutationFn: (fetchMutation: fetchMutationKey) => {
      return fetchResourceUpdate(fetchMutation);
    }
  });
}

export function useResourceDelete() {
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    mutationFn: (fetchMutation: fetchMutationKey) => {
      return fetchResourceDelete(fetchMutation);
    }
  });
}
